<template>
  <v-app id="vapp" class="d-flex flex-column justify-start align-center">
    <!--version 0.9.02-->
    <!--//@*/*
    //    *RPD  Appv0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC . All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    <v-overlay opacity="0.97" :z-index="zIndex" :value="overlay">
      <v-progress-circular
        :size="50"
        style="z-index: 5200"
        color="deep-orange accent-2"
        indeterminate
      >
      </v-progress-circular>
    </v-overlay>

    <div id="super-bannerhost">
      <banner
        id="bannerhost"
        style="width: 100%; height: 48px; max-width: 768px"
      ></banner>
    </div>

    <v-main id="main">
      <Transition name="fade-transition" mode="out-in">
        <router-view />
      </Transition>
    </v-main>
  </v-app>
</template>

<style>
.v-application--wrap {
  align-items: center;
  width: 100%;
}
#main {
  margin-top: 48px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
}
#super-bannerhost {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  height: 48px;
  position: fixed;
  z-index: 500;
}

.v-btn--active.no-active::before {
  opacity: 0 !important;
}

.v-btn--active.no-active:not(:hover)::before {
  opacity: 0 !important;
}

/* 0 media q */
@media (min-width: 0px) {
  #vapp {
    background-color: var(--v-background-base);
    overflow-y: auto;
    max-height: 100dvh;
    height: 100dvh;
  }

  .swal2-popup {
    /* font-size: 1.15rem !important;*/
    font-family: "Roboto", sans-serif !important;
  }
}

@media only screen and (max-width: 600px) {
  #vapp {
    max-height: 100dvh;
  }
}

@media (min-width: 768px) {
  #vapp {
    max-height: 100dvh;
  }
}

/* 1025 media q */
/* big landscape tablets, laptops, and desktops */
@media (min-width: 1025px) {
  #vapp {
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>

<script>
import banner from "./banner.vue";
import { bus_common } from "../mixins/bus_common";
export default {
  name: "App",
  mixins: [bus_common],
  components: { banner },

  data() {
    return {
      zIndex: 4000,
    };
  },
  watch: {
    "$store.state.loader_visible": function () {
      //console.log("app loader_visible " + this.$store.state.loader_visible );
    },
  },
  computed: {
    overlay: function () {
      return this.$store.state.loader_visible;
    },
    overlay_prn: function () {
      return this.$store.state.overlay_prn_show;
    },
  },
  methods: {
    logout() {
      this.swall_diag(
        "Log Out?",
        "Are you sure you would like to log out?",
        "question",
        null,
        "Yes",
        "No",
        null
      );
    },
  },
  created() {
    this.show_loader(true);
  },
};
</script>
